import React from 'react'
import EquityCalculator from '@rse/rent-calculator'
import { getAvailableHomes } from '../../firebase'

export default function EquityCalculatorPage() {
  return <EquityCalculator getAvailableHomes={getAvailableHomes} />
}
